import { Box, Typography } from '@mui/material';
import Table from '@tiptap/extension-table';
import TableCell from '@tiptap/extension-table-cell';
import TableHeader from '@tiptap/extension-table-header';
import TableRow from '@tiptap/extension-table-row';
import StarterKit from '@tiptap/starter-kit';
import {
  MenuButtonAddTable,
  MenuButtonBold,
  MenuButtonItalic,
  MenuControlsContainer,
  MenuDivider,
  MenuSelectHeading,
  RichTextEditor,
  type RichTextEditorRef,
} from 'mui-tiptap';
import { forwardRef, useImperativeHandle, useRef } from 'react';

type TextEditorProps = {
  content: string;
  title: string;
};

export type TextEditorRef = {
  getHTML: () => string;
};

export const TextEditor = forwardRef<TextEditorRef, TextEditorProps>(({ content, title }, ref) => {
  const rteRef = useRef<RichTextEditorRef>(null);

  useImperativeHandle(
    ref,
    () => ({
      getHTML: () => rteRef.current?.editor?.getHTML() ?? '',
    }),
    [],
  );

  return (
    <Box>
      <Typography variant='h4'>{title}</Typography>
      <RichTextEditor
        ref={rteRef}
        extensions={[StarterKit, Table, TableRow, TableHeader, TableCell]}
        content={content}
        renderControls={() => (
          <MenuControlsContainer>
            <MenuSelectHeading />
            <MenuDivider />
            <MenuButtonBold />
            <MenuButtonItalic />
            <MenuDivider />
            <MenuButtonAddTable />
            {/* Add more controls of your choosing here */}
          </MenuControlsContainer>
        )}
      />
    </Box>
  );
});
